// §11.8 / §9.1 — the PDF reader as an in-process app.
//
// A **viewer**, not an editor (the registry's ordering is what "Open with" reads), and the app
// Peek borrows its page renderer from — §11.1 says Peek is "used by" this, not a second reader.
import { createRoot, type Root } from 'react-dom/client';
import type { InProcessApp, PdfShellAccess } from '@hangar/shared';
import { Pdf } from './Pdf';
import './pdf.css';

const roots = new WeakMap<HTMLElement, Root>();

export function createPdfApp(access: PdfShellAccess): InProcessApp {
  return {
    id: 'pdf',
    name: 'PDF Reader',
    icon: { glyph: 'book-open', hue: 355 },
    keywords: ['pdf', 'document', 'reader', 'acrobat', 'paper'],
    window: { width: 940, height: 720, minWidth: 420, minHeight: 320, multiWindow: true },
    fileTypes: [{ ext: ['.pdf'], mime: ['application/pdf'], role: 'viewer' }],

    mount(container, api) {
      const root = createRoot(container);
      roots.set(container, root);
      root.render(<Pdf api={api} access={access} />);
    },

    unmount(container) {
      const root = roots.get(container);
      roots.delete(container);
      root?.unmount();
    },
  };
}
